<template>
  <v-card class="sv-card">
    <slot />
  </v-card>
</template>

<script>
export default {};
</script>
